import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from '../../components/feature/HeroSection';
import TrustBar from '../../components/feature/TrustBar';
import ServicesGrid from '../../components/feature/ServicesGrid';
import AIBlock from '../../components/feature/AIBlock';
import ProcessTimeline from '../../components/feature/ProcessTimeline';
import WhyChooseUs from '../../components/feature/WhyChooseUs';
import ServiceAreaMap from '../../components/feature/ServiceAreaMap';
import TestimonialsSection from '../../components/feature/TestimonialsSection';
import FAQAccordion from '../../components/feature/FAQAccordion';
import FinalCTASection from '../../components/feature/FinalCTASection';
import { FAQS, TRUST_ITEMS } from '../../mocks/sharedData';

const heroData = {
  eyebrow: 'Expert Solar Installation — Indiana & Kentucky',
  headline: 'Premium Solar Services for',
  headlineAccent: 'Every Property.',
  subheadline:
    'Residential, commercial, and nonprofit solar installations across Southern Indiana and North Central Kentucky. Transparent pricing, expert installation, lasting results.',
  primaryCTA: {
    label: 'Request a Free Estimate',
    href: 'https://meetings.hubspot.com/starsolarspecialists/solarpowerconsultation',
    external: true,
  },
  backgroundImage:
    'https://starsolarspecialists.com/wp-content/uploads/2021/07/54-print-4403-Hamburg-Pike-53-scaled.jpg',
};

const serviceCards = [
  {
    title: 'Residential Solar Installation',
    description:
      'We design and install custom solar systems for homes of all sizes. Ground-mounted and rooftop systems available. Homeowners can save 30% with the federal investment tax credit.',
    image:
      'https://starsolarspecialists.com/wp-content/uploads/2021/08/67-print-4900-Dunbar-Valley-rd-65-scaled-e1629667416567.jpg',
    href: '/services',
    badge: '30% Federal Tax Credit',
  },
  {
    title: 'Commercial Solar Installation',
    description:
      'We install solar for businesses of any size — from small offices to large commercial facilities. Businesses can depreciate up to 85% of the installation cost.',
    image:
      'https://starsolarspecialists.com/wp-content/uploads/2021/07/54-print-4403-Hamburg-Pike-53-scaled.jpg',
    href: '/services',
    badge: 'Up to 85% Depreciation',
  },
  {
    title: 'Nonprofit & Agricultural Solar',
    description:
      'Nonprofits and farms can significantly reduce operating costs through solar installations with customized financing strategies.',
    image:
      'https://starsolarspecialists.com/wp-content/uploads/2020/04/Star-Solar_HGRS1-e1588107192659.jpg',
    href: '/services',
  },
];

const aiData = {
  eyebrow: 'Our Solar Services',
  headline: 'Complete Solar Installation From Design to Grid Connection',
  description:
    'Star Solar Specialists handles every aspect of your solar project — system design, permitting, installation, and utility interconnection. We are licensed to install solar in both Indiana and Kentucky, making us the premier choice for the entire Kentuckiana region.',
  pillars: [
    {
      icon: 'ri-drafting-compass-line',
      title: 'Custom System Design',
      description: 'Every system is engineered for your specific roof, energy usage, and financial goals.',
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Permit Management',
      description: 'We handle all permits, utility applications, and interconnection agreements.',
    },
    {
      icon: 'ri-tools-line',
      title: 'Expert Installation',
      description: 'Licensed crews complete most residential installations in 1–3 days.',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Post-Install Support',
      description: 'We stand behind our work with ongoing support after your system goes live.',
    },
  ],
};

const serviceTrustItems = [
  { icon: 'ri-shield-check-line', label: 'Licensed in IN & KY', sub: 'Professionally Certified' },
  { icon: 'ri-home-gear-line', label: 'Family Owned', sub: 'Since 2015' },
  { icon: 'ri-percent-line', label: '30% Tax Credit', sub: 'Available Now' },
  { icon: 'ri-building-2-line', label: 'All Property Types', sub: 'Residential & Commercial' },
  { icon: 'ri-leaf-line', label: 'Clean Energy', sub: 'Reduce Your Footprint' },
];

const servicesFaqs = [
  ...FAQS,
  {
    question: 'Do you install ground-mounted solar systems?',
    answer: 'Yes. Star Solar Specialists installs both rooftop and ground-mounted solar systems. Ground-mounted systems are ideal for properties with limited roof space or sub-optimal roof orientation, and can often produce more energy due to flexible positioning.',
  },
];

const ServicesPage = () => (
  <main>
    <Navbar />
    <HeroSection data={heroData} />
    <TrustBar items={serviceTrustItems} />
    <ServicesGrid
      eyebrow="Our Installations"
      headline="Solar Power Solutions for Every Property Type"
      cards={serviceCards}
    />
    <AIBlock {...aiData} />
    <ProcessTimeline
      eyebrow="Our Installation Process"
      headline="From Consultation to First Kilowatt"
    />
    <WhyChooseUs
      eyebrow="Why Star Solar"
      headline="The Kentuckiana Solar Experts You Can Trust"
    />
    <ServiceAreaMap
      eyebrow="Licensed Service Area"
      headline="Indiana & Kentucky Solar Installations"
    />
    <TestimonialsSection
      eyebrow="Customer Reviews"
      headline="Rated 5 Stars Across Kentuckiana"
    />
    <FAQAccordion
      eyebrow="Service FAQs"
      headline="Everything You Need to Know About Solar Installation"
      items={servicesFaqs}
    />
    <FinalCTASection
      headline="Design Your Custom Solar System Today"
      subheadline="Get a free estimate from Kentuckiana's most trusted solar installation team. No pressure, no obligation — just expert guidance."
    />
    <Footer />
  </main>
);

export default ServicesPage;
